import api from '@/factories/api';
import { rootFolders } from '@/store/storeHelpers';

export default {
  namespaced: true,

  state: {
    folders: [],
    foldersLoaded: false,
    folderLoading: false,
  },

  mutations: {
    setFolders: (state, folders) => {
      state.folders = folders;
    },
    setFoldersLoaded: (state, loaded) => {
      state.foldersLoaded = loaded;
    },
    setFolderLoading: (state, loading) => {
      state.folderLoading = loading;
    },
  },

  getters: {
    getFolder(state) {
      const findFolder = (folders, folderId) => {
        for (const folder of folders) {
          if (folder.id === folderId) return folder;
          if (folder.folders?.length) {
            const found = findFolder(folder.folders, folderId);
            if (found) return found;
          }
        }
        return undefined;
      };
      return (folderId) => findFolder(state.folders, folderId);
    },
    rootFolders(state) {
      return rootFolders(state.folders);
    },
  },

  actions: {
    async loadFolders({ commit, state }) {
      if (state.foldersLoaded) return;

      try {
        const folders = await api().get('cg/files_folders?schema=full');
        commit('setFolders', folders);
      } finally {
        commit('setFoldersLoaded', true);
      }
    },

    async loadSingleFolder({ commit, getters, state }, folderId) {
      if (getters.getFolder(folderId)) return;

      try {
        const res = await api().get(`cg/files_folders/${folderId}?schema=full`);
        const folder = Array.isArray(res) ? res[0] : res;
        if (folder) commit('setFolders', [folder, ...state.folders]);
      } finally {
        commit('setFolderLoading', false);
      }
    },
  },
};
